import styled from "styled-components";
import {Checkbox as MuiCheckbox, FormControlLabel as MuiFormControlLabel} from '@mui/material';
import {colors} from "../../../themes";


export const StyledCheckbox = styled(MuiCheckbox)`
  && {
    box-sizing: border-box;
    .MuiFormControlLabel-root {
      box-sizing: border-box;
      padding: 0;
      margin: 0;
    }
    .MuiSvgIcon-root {
      color: ${colors.general.persianBlue};
    }
  }
`;

export const StyledFormControlLabel = styled(MuiFormControlLabel)`
  && {
    box-sizing: border-box;
    .MuiTypography-root {
      font-family: 'Lato';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 140%;
      color: ${colors.text.ebony};
    }
  }
`;
